export function initFolderSlider() {
  if (window.innerWidth < 768) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    console.log('FolderSlider: animazioni disabilitate per preferenza utente.');
    return;
  }

  const slides = document.querySelectorAll('.ScrollingSections__Slide');
  if (!slides || slides.length === 0) return;

  slides.forEach((slide, index) => {
    const isLast = index === slides.length - 1;
    const contentWrapper = slide.querySelector('.ScrollingSections__WrapperSlide');

    if (!contentWrapper) return;

    if (!isLast) {
      gsap.to(contentWrapper, {
        rotationZ: (Math.random() - 0.5) * 10,
        scale: 0.7,
        rotationX: 40,
        ease: 'power1.in',
        scrollTrigger: {
          pin: contentWrapper,
          trigger: slide,
          start: 'top 0%',
          end: '+=' + window.innerHeight,
          scrub: true,
        }
      });
    } else {
      ScrollTrigger.create({
        trigger: slide,
        start: 'top 0%',
        end: 'bottom bottom',
        pin: contentWrapper,
        pinSpacing: false,
      });
    }
  });
}